import { render, staticRenderFns } from "./ImportSupplier.vue?vue&type=template&id=35dea0c4&scoped=true"
import script from "./ImportSupplier.vue?vue&type=script&lang=js"
export * from "./ImportSupplier.vue?vue&type=script&lang=js"
import style0 from "./ImportSupplier.vue?vue&type=style&index=0&id=35dea0c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dea0c4",
  null
  
)

export default component.exports